var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.context.repeatable &&
      _vm.context.model.length > _vm.context.minimum &&
      _vm.isRemovable
  )?_c('a',{staticClass:"remove-button",class:_vm.context.classes.groupRepeatableRemove,attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem.apply(null, arguments)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.removeItem.apply(null, arguments)}}},[_c('FontAwesomeIcon',{attrs:{"icon":"minus-circle"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }